import { useContext } from "react";
import { Checkbox } from "@mui/material";
import { CheckOutlined } from "@ant-design/icons";
import { ModalActionContext } from "../../lib/hooks/useModalAction";
import { EcoLabel } from "./ecoLabel";
import css from "./organicCheckbox.module.css";

interface OrganicCheckboxProps {
  checked: boolean;
  onChange(checked: boolean): void;
  disabled?: boolean;
}

export function OrganicCheckbox(props: OrganicCheckboxProps) {
  const { isBusy } = useContext(ModalActionContext);

  return (
    <label className={css.row}>
      <span className={css.label}>
        <EcoLabel size={2} color={props.checked ? undefined : "#d1d5db"} />
        {props.checked ? "Økologisk" : "Ikke økologisk"}
      </span>
      <Checkbox
        checked={props.checked}
        onChange={(event) => props.onChange(event.target.checked)}
        disabled={props.disabled || isBusy}
        disableRipple
        icon={<span className={css.mark} />}
        checkedIcon={
          <span className={`${css.mark} ${css.checked}`}>
            <CheckOutlined />
          </span>
        }
        sx={{
          padding: 0,
          backgroundColor: "transparent",
          WebkitTapHighlightColor: "transparent",
          "&:hover, &:active": { backgroundColor: "transparent" },
          "&.Mui-focusVisible": {
            backgroundColor: "transparent",
            outline: "2px solid #9ca3af",
            outlineOffset: 4,
            borderRadius: "7px",
          },
          "&.Mui-disabled": { opacity: 0.5 },
        }}
        slotProps={{
          input: {
            "aria-label": props.checked ? "Økologisk" : "Ikke økologisk",
          },
        }}
      />
    </label>
  );
}
